import React, { ReactNode } from "react"

import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import { STEPS, Step } from "./helpers"

import * as styles from "./howSteps.module.scss"

const titleDefault = (
  <>
    Как оформить карту <br className="d-sm-none" /> рассрочки* «Халва»
  </>
)

type HowStepsProps = {
  orderNum?: string
  title?: ReactNode
  items?: Step[]
  variantStyles?: "plait" | "cashback_factory" | "cashback100"
}

export const HowSteps = ({
  orderNum,
  title = titleDefault,
  items = STEPS,
  variantStyles = "cashback_factory",
}: HowStepsProps) => (
  <section
    id="howToGet"
    className={clsx(styles.section, variantStyles && styles[variantStyles])}
    data-exclude={orderNum}
  >
    <Container>
      <h2 className={styles.title}>{title}</h2>
      <div>
        <ul className={styles.steps}>
          {items.map((item, i) => (
            <li key={i} className={styles.step}>
              <div className={styles.stepNumber}>{i + 1}</div>
              <p className={styles.text}>{item.title}</p>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  </section>
)
